module.exports = __webpack_public_path__ + "9cf19a3e57728a226945456311054474.png";